import { useState } from "react";
import { Bell } from "react-feather";
import { Alert, Card, CardBody, Col } from "reactstrap";
import { DismissingLightAlertTitle } from "../../../constants";
import { DismissAlertSubTitle } from "../../../data/uiKits/Alert";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";

const DismissingLightAlert = () => {
  const [active, setActive] = useState(true);
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={DismissingLightAlertTitle} span={DismissAlertSubTitle} />
        <CardBody>
          <Alert color="warning" isOpen={active} toggle={() => setActive(false)}>
            <Bell />
            <p>{"Hidden content You should check in on some of those fields below."}</p>
          </Alert>
        </CardBody>
      </Card>
    </Col>
  );
};
export default DismissingLightAlert;
